import { NOT } from '@/lib/filter/scope-tree';

// extractSpaceIds is an approximation of spaces represented by a goal
// filter. Approximation is achieved, by only looking at space based
// filters. Any other filter type is ignored.
//
// ust = user scope tree
export const extractSpaceIds = ({ filter, properties, spaces }) => {
  if (filter === null) {
    return [];
  }

  const isSpaceFilter = (ust) => {
    if (!Array.isArray(ust.scope?.spaces)) {
      return false;
    }
    if (ust.scope.property === undefined) {
      return false;
    }
    if (properties.find((p) => p.uid === ust.scope.property.uid) === undefined) {
      return false;
    }
    return true;
  };

  const spaceReducer = (op) => (acc, ust) => {
    if (ust.children === undefined || ust.children.length === 0) {
      if (!isSpaceFilter(ust)) {
        return acc;
      }

      if (op === NOT) {
        const ustSpaces = ust.scope.spaces.map((space) => space.uid);
        acc.push(...spaces.filter((s) => !ustSpaces.includes(s.uid)).map((s) => s.uid));
        return acc;
      }

      acc.push(...ust.scope.spaces.map((space) => space.uid));
      return acc;
    }

    const children = ust.children.reduce(spaceReducer(op === NOT ? NOT : ust.op), []);
    if (children.length > 0) {
      acc.push(...children);
    }
    return acc;
  };

  return filter.children.reduce(spaceReducer(filter.op), []);
};
